module.exports = __webpack_public_path__ + "img/kv.bc9ca30b.svg";